/**
 * @generated SignedSource<<8cdddffdd2a6145fe229892a2ab9eb79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SignatureEnvelopeState = "CANCELLED" | "CERTIFYING" | "COMPLETED" | "COMPLETING" | "SIGNING" | "%future added value";
export type SignatureState = "REJECTED" | "SIGNED" | "WAITING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SignatureStatusFileRenderer_node$data = {
  readonly __typename: string;
  readonly id: string;
  readonly isSignable?: boolean;
  readonly signatureEnvelope?: {
    readonly canDelete: {
      readonly value: boolean;
    };
    readonly canSign: {
      readonly value: boolean;
    };
    readonly currentFile: {
      readonly __typename: "File";
      readonly fileName: string;
      readonly fileNameWithExtension: string;
      readonly id: string;
      readonly mimeType: string;
      readonly name: string;
      readonly size: number;
      readonly url: URIString;
    };
    readonly id: string;
    readonly signatures: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly member: {
          readonly id: string;
        };
        readonly status: SignatureState;
      }>;
    };
    readonly status: SignatureEnvelopeState;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ManagersSteps_node">;
  readonly " $fragmentType": "SignatureStatusFileRenderer_node";
};
export type SignatureStatusFileRenderer_node$key = {
  readonly " $data"?: SignatureStatusFileRenderer_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignatureStatusFileRenderer_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignatureStatusFileRenderer_node",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSignable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SignatureEnvelope",
          "kind": "LinkedField",
          "name": "signatureEnvelope",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "SignaturesConnection",
              "kind": "LinkedField",
              "name": "signatures",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Signature",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Member",
                      "kind": "LinkedField",
                      "name": "member",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v2/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "File",
              "kind": "LinkedField",
              "name": "currentFile",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fileName",
                  "storageKey": null
                },
                {
                  "alias": "fileNameWithExtension",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "ensureExtension",
                      "value": true
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "fileName",
                  "storageKey": "fileName(ensureExtension:true)"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mimeType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "size",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AuthorizationResult",
              "kind": "LinkedField",
              "name": "canSign",
              "plural": false,
              "selections": (v3/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AuthorizationResult",
              "kind": "LinkedField",
              "name": "canDelete",
              "plural": false,
              "selections": (v3/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "SignableInterface",
      "abstractKey": "__isSignableInterface"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ManagersSteps_node"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "f5a10e4bae76715e52fc98c0d97b4717";

export default node;
